type Props = {
  img?: string;
  title: string;
  body: string;
};

export default function CustomNotification({ title, body }: Props) {
  return (
    <div className="flex items-center gap-4">
      {/* {img && (
        <div className="w-[72px] h-[72.40px] bg-[#ffa0a0]/20 rounded">
          <img
            src={img}
            alt=""
            className="w-full h-full object-cover rounded"
          />
        </div>
      )} */}

      <div className="flex-1 h-full">
        <h3 className="text-body text-base font-medium w-[calc(100%-22px)] whitespace-nowrap overflow-hidden text-ellipsis">
          {title}
        </h3>
        <p className="text-muted text-xs font-medium mt-1.5 mb-1 w-full">
          {body}
        </p>
      </div>
    </div>
  );
}
